// Module
var code = "<md-menu-item class=\"sb-progress-options__item\"> <md-button data-cy=\"{{$ctrl.key}}\" ng-disabled=\"$ctrl.disabled\" ng-click=\"$ctrl.handleClick($event);\"> <ng-transclude></ng-transclude> </md-button> </md-menu-item> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/components/sbProgressOptions/progress_options_item.tmpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;